<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\score_static_new_1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào icon [Tình hình học tập] trên thanh tiêu đề, chọn thanh [Thành tích học tập] để xem thành tích thi của các kỳ thi.</p>
                </div>
                <div><img src="/static\images\vi\newManual\courseConditionsManual-5.png" alt="" /></div>
                <div>
                    <p>※ Các khóa học được hiển thị trong bảng số liệu không bao gồm các khóa học đã kết thúc (tức những khóa học bạn đã học xong và đã gửi [Yêu cầu kết thúc]).</p>
                    <p>Các thông tin cuối cùng của kì thi:</p>
                    <p>&nbsp; Điểm hiện tại: điểm lần thi cuối cùng của học viên (học viên có thể thi nhiều lần, và hệ thống sẽ ghi nhận thành tích lần thi cuối cùng của học viên</p>
                    <p>&nbsp; Điểm trung bình: điểm trung bình của tất cả các học viên tham gia thi</p>
                    <p>&nbsp; Điểm cao nhất: thành tích cao nhất xét trên tất cả các học viên</p>
                    <p>&nbsp; Điểm thấp nhất: thành tích thấp nhất xét trên tất cả các học viên</p>
                    <p>&nbsp; Điểm chuẩn: điểm chuẩn để đánh giá việc Đậu/Không đậu</p>
                    <p>&nbsp; Đánh giá: Đậu/Không đậu</p>
                    <p>&nbsp; Số người đậu/không đậu kì thi</p>
                </div>

                <div><img src="/static\images\vi\newManual\courseConditionsManual-6.png" alt="" /></div>
                <div>
                    <p>&nbsp; Điểm thi hiện tại, và đánh giá đậu/không đậu hiển thị trong bảng này được lấy dựa trên lần thi cuối cùng của học viên.tất cả các lần dự thi.</p>
                    <p>&nbsp; Tuy nhiên, có thể nhấn vào nút [Hiển thị] của cột [Xem lịch sử dự thi] để xem lịch sử của tất cả các lần thi trước đó.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p><b>❖ Nhấn vào ô [Thành tích học tập] sẽ hiển thị thông tin thành tích bạn đã thi.</b></p></div>
                <div><img src="/static\images\vi\newManual\mobile\score_static_mb_new_1.png" alt="" /></div>
                <div><p>① Bạn muốn tìm kiếm khóa học nhập tên khóa học ô tìm kiếm và nhấn nút [tìm kiếm].</p></div>
                <div><p>② Khi nhấn vào nút [Gồm cả khóa học hoàn thành] sẽ hiển thị những khóa học mà bạn đã yêu cầu kết thúc khóa học.</p></div>
                <div><p>③ Hiển thị danh sách các khóa học bạn đã tham gia thi.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\score_static_mb_new_2.png" alt="" /></div>
                <div><p>④ Khi chọn vào sẽ hiển thị thông [Số lượng học viên], [Điểm hiện tại], [Điểm trung bình], [Điểm cao nhẩt], [Điểm thấp nhất], [Điểm chuẩn], [Đánh giá], [Xem lịch sử dự thi], [Đậu], [Rớt] của khóa học đó.</p></div>
                <div><p>● Số lượng học viên: Tổng số lượng học viên trong khóa học đó.</p></div>
                <div><p>● Điểm hiện tại: Là điểm bạn thi được trong bài thi (Bạn có thể click vào điểm để di chuyển đến trang thành tích thi của bạn).</p></div>
                <div><p>● Điểm trung bình: Điểm trung bình của tất cả học viên trong khóa học đã thi.</p></div>
                <div><p>● Điểm cao nhất: Điểm cao nhất của học viên trong khóa học đó.</p></div>
                <div><p>● Điểm thấp nhất: Điểm thấp nhất của học viên trong khóa học đó.</p></div>
                <div><p>● Điểm chuẩn: Là điểm vượt qua bài thi để đánh giá học viên đó đậu hay rớt.</p></div>
                <div><p>● Đánh giá: Là phần đánh giá học viên đó thi đậu hay rớt.</p></div>
                <div><p>● Xem lịch sử dự thi: Khi bạn click vào nút [hiển thị] sẽ di chuyển đến trang lịch sử dự thi của bạn.</p></div>
                <div><p>● Đậu: Xem được số lượng và tỉ lệ học viên đậu trong khóa đó.</p></div>
                <div><p>●Không đậu: Xem được số lượng và tỉ lệ học viên không đậu trong khóa đó.</p></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/scoreStatistics_manual.vue